export default __webpack_public_path__ + "static/media/caramel-mecchiato-v2.867f3796.png";